<template>
  <div id="ContentEditPanel">
    <div class="left" :class="'col-xs-' + 12 / $store.getters.divider">
      <div class="mlr0 grid-layout">
        <div v-for="(i, index) in content" :key="index" class="prl7 mb10" :style="$store.getters.getGridPosition(index, 'leftSide')">
          <div class="p5 border relative" v-if="!i.disabled" >
            <el-input-number :min="0" :max="9" size="small" v-if="i.hasTextL1 && i.isNumber"
              :disabled="isBigIcon(i) || i.disabled" v-model="i.textL1" class="mb10" minlength="3"></el-input-number>
            <el-input v-if="i.hasTextL1 && !i.isNumber" :disabled="isBigIcon(i) || i.disabled" v-model="i.textL1"
              class="mb10" minlength="3" :maxlength="maxLength"></el-input>
            <el-input v-if="i.hasTextL2" :disabled="isBigIcon(i)" v-model="i.textL2" class="mb10"
              :maxlength="maxLength"></el-input>
            <div class="sele-svg">
              <IconInput v-if="i.hasIcon" v-model="i.icon" class="inline" :icons-set="iconsSet"
                :series="iconType(index, 'layout')" :popper-class="iconType(index, 'layout')" />
            </div>
          </div>
        </div>
      </div>
      <el-checkbox v-if="$store.state.artwork.type === 'aria' && $store.state.artwork.layout === 'M1'" v-model="ariaM1IconsLeftSide">Show side control touch point</el-checkbox>
    </div>
    <div class="right" v-if="format != 'single'" :class="{
      ['col-xs-' + 12 / $store.getters.divider]: true,
      'bdr-d': !$store.getters.isVertical, 'bdrt-d': $store.getters.isVertical
    }">
      <div class="mlr0 grid-layout">
        <div class="prl7 mb10" :style="$store.getters.getGridPosition(index, 'rightSide')" v-for="(i, index) in rightContent"
          :key="index" >
          <div class="p5 border relative" v-if="!i.disabled">
            <el-input-number :min="0" :max="9" size="small" v-if="i.hasTextL1 && i.isNumber"
              :disabled="isBigIcon(i) || i.disabled" v-model="i.textL1" class="mb10"></el-input-number>
            <el-input v-if="i.hasTextL1 && !i.isNumber" :disabled="isBigIcon(i) || i.disabled" v-model="i.textL1"
              class="mb10" minlength="3" :maxlength="rightMaxLength"></el-input>
            <el-input v-if="i.hasTextL2" :disabled="isBigIcon(i)" v-model="i.textL2" class="mb10" minlength="3"
              :maxlength="rightMaxLength"></el-input>
            <div class="sele-svg">
              <IconInput v-if="i.hasIcon" v-model="i.icon" class="inline" :icons-set="iconsSet"
                :series="iconType(index, 'rightLayout')" :popper-class="iconType(index, 'rightLayout')" />
            </div>
          </div>
        </div>
      </div>
      <el-checkbox
      v-if="$store.state.artwork.type == 'aria' && $store.state.artwork.rightLayout == 'M1'"
      v-model="ariaM1IconsRightSide"
    >Show side control touch point</el-checkbox> 
    </div>

    <div :class="{
      ['col-xs-' + 12 / $store.getters.divider]: true,
      'bdr-d': !$store.getters.isVertical, 'bdrt-d': $store.getters.isVertical
    }" >
      <div class="mlr0 grid-layout" v-if="$store.getters.isTriple">
        <div class="prl7 mb10" :style="$store.getters.getGridPosition(index, 'tripleRightSide')"
          v-for="(i, index) in tripleRightContent" :key="index">
          <div class="p5 border relative" v-if="!i.disabled">
            <el-input-number :min="0" :max="9" size="small" v-if="i.hasTextL1 && i.isNumber"
              :disabled="isBigIcon(i) || i.disabled" v-model="i.textL1" class="mb10"></el-input-number>
            <el-input v-if="i.hasTextL1 && !i.isNumber" :disabled="isBigIcon(i) || i.disabled" v-model="i.textL1"
              class="mb10" minlength="3" :maxlength="tripleRightMaxLength"></el-input>
            <el-input v-if="i.hasTextL2" :disabled="isBigIcon(i)" v-model="i.textL2" class="mb10" minlength="3"
              :maxlength="tripleRightMaxLength"></el-input>
            <div class="sele-svg">
              <IconInput v-if="i.hasIcon" v-model="i.icon" class="inline" :icons-set="iconsSet"
                :series="iconType(index, 'tripleRightLayout')" :popper-class="iconType(index, 'tripleRightLayout')" />
            </div>
          </div>
        </div>
      </div>
      <el-checkbox
      v-if="$store.state.artwork.type == 'aria' && $store.state.artwork.tripleRightLayout == 'M1'"
      v-model="ariaM1IconsTripleRightSide"
    >Show side control touch point</el-checkbox>
    </div>
  </div>
</template>
<script>
import IconInput from "../../../components/IconInput.vue";
import isBigIconMixin from '../../../mixins/isBigIconMixin';

export default {
  name: "ContentEditPanel",
  components: {
    IconInput
  },
  mixins: [
    isBigIconMixin
  ],
  data() {
    return {
      ariaM1IconsLeftSide: this.$store.state.artwork.layoutAriaM1TempIcons || false,
      ariaM1IconsRightSide: this.$store.state.artwork.rightLayoutAriaM1TempIcons || false,
      ariaM1IconsTripleRightSide: this.$store.state.artwork.tripleRightLayoutAriaM1TempIcons || false,
      type: null,
      layout: null,
      rightLayout: null,
      tripleRightLayout: null,
      content: null,
      rightContent: null,
      tripleRightContent: null,
      format: null,
      font: null,
      contentEditBoxType: {
        iconOnly: { iconEditBox: true },
        singleLineText: { textEditBoxL1: true },
        doubleLineText: { textEditBoxL1: true, textEditBoxL2: true },
        iconSingleLineTextMid: { textEditBoxL1: true, iconEditBox: true },
        iconDoubleLineTextMid: {
          textEditBoxL1: true,
          textEditBoxL2: true,
          iconEditBox: true,
        },
        iconSingleLineText: { textEditBoxL1: true, iconEditBox: true },
        iconDoubleLineText: {
          textEditBoxL1: true,
          textEditBoxL2: true,
          iconEditBox: true,
        },
      },
      fontSizeLength: {
        // "Avenir": {
        //   ariatt: { //only for first two buttons
        //     2.5: 7,
        //     3.5: 5,
        //     4.5: 3,
        //   },
        //   aria: {
        //     2.5: 9,
        //     3.5: 7,
        //     4.5: 4,
        //   },
        //   alba: {
        //     2.5: 15,
        //     3.5: 12,
        //     4.5: 9,
        //   },
        //   axes: {
        //     2.5: 9,
        //     3.5: 7,
        //     4.5: 4,
        //   },
        // },
        "Avenir Black Nova": {
          ariatt: { //only for first two buttons
            2.5: 7,
            3.5: 5,
            4.5: 3,
          },
          aria: {
            2.5: 9,
            3.5: 8,
            4.5: 4,
          },
          alba: {
            2.5: 15,
            3.5: 12,
            4.5: 9,
          },
          axes: {
            2.5: 9,
            3.5: 8,
            4.5: 4,
          },
          blackjack: {
            2.5: 8,
            3.5: 8,
            4.5: 8,
          },
        },
        "Black Nova Metal": {
          alba: {
            3.5: 8,
          },
          blackjack: {
            3.5: 8,
          },
        },
      }, 
      layoutMap: {
        layout : ['leftSideLeftButton', 'leftSideRightButton'],
        rightLayout : ['rightSideLeftButton', 'rightSideRightButton'],
        tripleRightLayout : ['tripleRightSideLeftButton', 'tripleRightSideRightButton']
      }
    };
  },
  mounted() {
    //read from store
    this.type = this.$store.state.artwork.type;
    this.font = this.$store.state.artwork.fontType;
    this.format = this.$store.state.artwork.format;
    this.content = this.$store.state.artwork.content;
    this.rightContent = this.$store.state.artwork.rightContent;
    this.tripleRightContent = this.$store.state.artwork.tripleRightContent;
    this.layout = this.$store.state.artwork.layout;
    this.rightLayout = this.$store.state.artwork.rightLayout;
    this.tripleRightLayout = this.$store.state.artwork.tripleRightLayout;
  },
  computed: {
    iconsSet() {
      if (this.$store.getters.isFullMetal) {
        return 'metal';
      }
      return 'default';
    },
    maxLength() {
      if (this.type == null || typeof this.$store.state.artwork.fontSize == 'undefined') return 0;
      if (this.$store.getters.isFullMetal && (this.$store.state.artwork.layoutStyle == 'iconSingleLineText' || this.$store.state.artwork.layoutStyle == 'iconDoubleLineText')) {
        if (this.type == 'alba') {
          return 6; //Limit texts to 6 characters for icon and text combinations on full metal
        } else {
          return 5;
        }

      }
      return this.fontSizeLength[this.font][this.type][this.$store.state.artwork.fontSize];
    },
    rightMaxLength() {
      if (this.type == null || typeof this.$store.state.artwork.rightFontSize == 'undefined') return 0;
      if (this.$store.getters.isFullMetal && (this.$store.state.artwork.rightLayoutStyle == 'iconSingleLineText' || this.$store.state.artwork.rightLayoutStyle == 'iconDoubleLineText')) {
        if (this.type == 'alba') {
          return 6; //Limit texts to 6 characters for icon and text combinations on full metal
        } else {
          return 5;
        }
      }
      return this.fontSizeLength[this.font][this.type][
        this.$store.state.artwork.rightFontSize
      ];
    },
    tripleRightMaxLength() {
      if (this.type == null || typeof this.$store.state.artwork.tripleRightFontSize == 'undefined') return 0;
      if (this.$store.getters.isFullMetal && (this.$store.state.artwork.tripleRightLayoutStyle == 'iconSingleLineText' || this.$store.state.artwork.tripleRightLayoutStyle == 'iconDoubleLineText')) {
        if (this.type == 'alba') {
          return 6; //Limit texts to 6 characters for icon and text combinations on full metal
        } else {
          return 5;
        }
      }
      return this.fontSizeLength[this.font][this.type][
        this.$store.state.artwork.tripleRightFontSize
      ];
    }
  },
  watch: {
    ariaM1IconsLeftSide(newVal) {
      this.$store.state.artwork.layoutAriaM1TempIcons = newVal;
      this.$store.commit("getContent");
      this.content = this.$store.state.artwork.content;
    },
    ariaM1IconsRightSide(newVal) {
      this.$store.state.artwork.rightLayoutAriaM1TempIcons = newVal;
      this.$store.commit("getRightContent");
      this.rightContent = this.$store.state.artwork.rightContent;
    },
    ariaM1IconsTripleRightSide(newVal) {
      this.$store.state.artwork.tripleRightLayoutAriaM1TempIcons = newVal;
      this.$store.commit("getTripleRightContent");
      this.tripleRightContent = this.$store.state.artwork.tripleRightContent;
    },
    content: {
      deep: true,
      handler(val) {
        val = val.map((i) => {
          if (this.isBigIcon(i)) {
            i.textL1 = "";
            i.textL2 = "";
          }
          return i;
        });

        this.$store.state.artwork.content = val;
      },
    },
    rightContent: {
      deep: true,
      handler(val) {
        if (val) {
          val = val.map((i) => {
            if (this.isBigIcon(i)) {
              i.textL1 = "";
              i.textL2 = "";
            }
            return i;
          });

          this.$store.state.artwork.rightContent = val;
        }
      },
    },
    tripleRightContent: {
      deep: true,
      handler(val) {
        if (val) {
          val = val.map((i) => {
            if (this.isBigIcon(i)) {
              i.textL1 = "";
              i.textL2 = "";
            }
            return i;
          });

          this.$store.state.artwork.tripleRightContent = val;
        }

      },
    },
    maxLength(newVal, oldVal) {
      if (newVal < oldVal) {
        this.content = this.content.map((c) => {
          if (typeof c.textL1 != "undefined" && !c.isNumber) {
            c.textL1 = c.textL1.substr(0, newVal);
          }
          if (typeof c.textL2 != "undefined") {
            c.textL2 = c.textL2.substr(0, newVal);
          }
          return c;
        });
      }
    },
    rightMaxLength(newVal, oldVal) {
      if (newVal < oldVal) {
        this.rightContent = this.rightContent.map((c) => {
          if (typeof c.textL1 != "undefined" && !c.isNumber) {
            c.textL1 = c.textL1.substr(0, newVal);
          }
          if (typeof c.textL2 != "undefined") {
            c.textL2 = c.textL2.substr(0, newVal);
          }
          return c;
        });
      }
    },
    tripleRightMaxLength(newVal, oldVal) {
      if (newVal < oldVal) {
        this.tripleRightContent = this.tripleRightContent.map((c) => {
          if (typeof c.textL1 != "undefined" && !c.isNumber) {
            c.textL1 = c.textL1.substr(0, newVal);
          }
          if (typeof c.textL2 != "undefined") {
            c.textL2 = c.textL2.substr(0, newVal);
          }
          return c;
        });
      }
    },
  },
  methods: {
    iconType(id, layout) {

      if (this.type == "alba") {
        let rightIndexStart = 0;
        //only buttom buttons
        if (this.$store.state.artwork[layout] == "M1" && (id == 0 || id == 2)) {
          return "NoDouble";
        }

        //only center buttons
        if (['B', 'D'].includes(this.$store.state.artwork[this.layoutMap[layout][0]])){
          rightIndexStart = 4;
          if ([1,2].includes(id)) {
            return "NoDouble";
          }
        } else if (this.$store.state.artwork[this.layoutMap[layout][0]] == "A"){
          rightIndexStart = 2;
          if ([0,1].includes(id)) {
            return "NoDouble";
          }
        }

         if ((['B', 'D'].includes(this.$store.state.artwork[this.layoutMap[layout][1]]) && [rightIndexStart + 1, rightIndexStart + 2].includes(id))) {
          return "NoDouble";
        } else if (this.$store.state.artwork[this.layoutMap[layout][1]] == "A" && [rightIndexStart, rightIndexStart + 1].includes(id)) {
          return "NoDouble";
        }
      }

      if (this.type == "blackjack") {
        let rightIndexStart = 0;
        //only buttom buttons
        if (this.$store.state.artwork[layout] == "M1" && (id == 0 || id == 2)) {
          return "NoDouble";
        }

        //only center buttons
        if (['D'].includes(this.$store.state.artwork[this.layoutMap[layout][0]])){
          rightIndexStart = 4;
          if ([1,2].includes(id)) {
            return "NoDouble";
          }
        } 

         if ((['D'].includes(this.$store.state.artwork[this.layoutMap[layout][1]]) && [rightIndexStart + 1, rightIndexStart + 2].includes(id))) {
          return "NoDouble";
        } 

        if (['A', 'B', 'C'].includes(this.$store.state.artwork[this.layoutMap[layout][0]]) || ['A', 'B', 'C'].includes(this.$store.state.artwork[this.layoutMap[layout][1]])){
            return "NoDouble";
        }
      }

      if (this.$store.getters.isFullMetal) {
        if (this.type == "alba") {
          return "alba";
        } else if (this.type == "blackjack" && this.$store.getters.squareOrRectangle == "rectangle") {
          return "blackjack|rectangle";
        }
      }

      if (this.type == "aria" && this.$store.state.artwork[layout] == "L12") {
        return "aria|L12";
      }

      return this.type;
    },
  },
};
</script>
